import RequestedServicesForm from "../../../../../guest-user/components/forms/RequestedServicesForm";

type SourceType = "MANUAL" | "POLICY";

interface RequestedServicesProps {
  isEditable?: boolean;
  caseSource?: SourceType;
  benefitSelections?: any[];
  lineItems?: any[];
  claimId?: string;
  claimStatus?: string;
  canEditPackage?: boolean;
  onPackageSelected?: (
    categoryCode: string,
    packageCode: string,
    lineItems: Array<{ quotableItemCode: string; quantity: number; unitPrice: number }>,
  ) => void | Promise<void>;
}

export default function RequestedServices({
  isEditable = false,
  caseSource = "MANUAL",
  benefitSelections = [],
  lineItems = [],
  claimId,
  claimStatus,
  canEditPackage,
  onPackageSelected,
}: RequestedServicesProps) {
  return (
    <RequestedServicesForm
      isEditable={isEditable}
      caseSource={caseSource}
      benefitSelections={benefitSelections}
      lineItems={lineItems}
      claimId={claimId}
      claimStatus={claimStatus}
      canEditPackage={canEditPackage}
      onPackageSelected={onPackageSelected}
    />
  );
}
